import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import { notify } from 'reapop'
import TermsConditionsService from '../middlewares/termsConditions'
import {
  GET_TERMS_CONDITIONS_REQUEST,
  GET_TERMS_CONDITIONS,
  CREATE_TERMS_CONDITIONS_REQUEST,
  CREATE_TERMS_CONDITIONS,
  UPDATE_TERMS_CONDITIONS_REQUEST,
  UPDATE_TERMS_CONDITIONS,
  DELETE_TERMS_CONDITIONS_REQUEST,
  DELETE_TERMS_CONDITIONS,
  GET_TERMS_CONDITIONS_REQUEST_PENDING,
  GET_TERMS_CONDITIONS_REQUEST_SUCCESS,
  GET_TERMS_CONDITIONS_REQUEST_ERROR,
  CHANGE_TERMS_CONDITIONS_REQUEST_PENDING,
  CHANGE_TERMS_CONDITIONS_REQUEST_SUCCESS,
  CHANGE_TERMS_CONDITIONS_REQUEST_ERROR,
} from '../types/termsConditions'

function* getTermsConditionsWatcher() {
  yield takeEvery(GET_TERMS_CONDITIONS_REQUEST, getTermsConditionsWorker)
}

function* createTermsConditionsWatcher() {
  yield takeEvery(CREATE_TERMS_CONDITIONS_REQUEST, createTermsConditionsWorker)
}

function* updateTermsConditionsWatcher() {
  yield takeEvery(UPDATE_TERMS_CONDITIONS_REQUEST, updateTermsConditionsWorker)
}

function* deleteTermsConditionsWatcher() {
  yield takeEvery(DELETE_TERMS_CONDITIONS_REQUEST, deleteTermsConditionsWorker)
}

function* getTermsConditionsWorker() {
  try {
    yield put(showLoading())
    yield put({ type: GET_TERMS_CONDITIONS_REQUEST_PENDING })
    const response = yield call(TermsConditionsService.getTermsConditions)
    yield put({ type: GET_TERMS_CONDITIONS, payload: response.data.data || [] })
    yield put({ type: GET_TERMS_CONDITIONS_REQUEST_SUCCESS })
  } catch (error) {
    yield put({
      type: GET_TERMS_CONDITIONS_REQUEST_ERROR,
      payload: error?.response?.data?.messages || [{ message: 'Failed to fetch terms and conditions' }],
    })
  } finally {
    yield put(hideLoading())
  }
}

function* createTermsConditionsWorker({ payload }) {
  const { data, onSuccess, onError } = payload || {}
  try {
    yield put(showLoading())
    yield put({ type: CHANGE_TERMS_CONDITIONS_REQUEST_PENDING })
    const response = yield call(TermsConditionsService.createTermsConditions, data || payload)
    yield put({ type: CREATE_TERMS_CONDITIONS, payload: response.data.data })
    yield put({ type: CHANGE_TERMS_CONDITIONS_REQUEST_SUCCESS })
    yield call(getTermsConditionsWorker)
    yield put(notify({ status: 'success', title: 'Terms saved successfully', dismissAfter: 3000 }))
    if (typeof onSuccess === 'function') {
      yield call(onSuccess, response.data.data)
    }
  } catch (error) {
    yield put({
      type: CHANGE_TERMS_CONDITIONS_REQUEST_ERROR,
      payload: error?.response?.data?.messages || [{ message: 'Failed to create terms and conditions' }],
    })
    if (typeof onError === 'function') {
      yield call(onError, error)
    }
  } finally {
    yield put(hideLoading())
  }
}

function* updateTermsConditionsWorker({ payload }) {
  const { id, data, onSuccess, onError } = payload || {}
  try {
    yield put(showLoading())
    yield put({ type: CHANGE_TERMS_CONDITIONS_REQUEST_PENDING })
    const response = yield call(TermsConditionsService.updateTermsConditions, id, data)
    yield put({ type: UPDATE_TERMS_CONDITIONS, payload: response.data.data })
    yield put({ type: CHANGE_TERMS_CONDITIONS_REQUEST_SUCCESS })
    yield call(getTermsConditionsWorker)
    yield put(notify({ status: 'success', title: 'Terms updated successfully', dismissAfter: 3000 }))
    if (typeof onSuccess === 'function') {
      yield call(onSuccess, response.data.data)
    }
  } catch (error) {
    yield put({
      type: CHANGE_TERMS_CONDITIONS_REQUEST_ERROR,
      payload: error?.response?.data?.messages || [{ message: 'Failed to update terms and conditions' }],
    })
    if (typeof onError === 'function') {
      yield call(onError, error)
    }
  } finally {
    yield put(hideLoading())
  }
}

function* deleteTermsConditionsWorker({ payload }) {
  const { id, onSuccess, onError } = payload || {}
  try {
    yield put(showLoading())
    yield put({ type: CHANGE_TERMS_CONDITIONS_REQUEST_PENDING })
    yield call(TermsConditionsService.deleteTermsConditions, id)
    yield put({ type: DELETE_TERMS_CONDITIONS, payload: id })
    yield put({ type: CHANGE_TERMS_CONDITIONS_REQUEST_SUCCESS })
    yield call(getTermsConditionsWorker)
    yield put(notify({ status: 'success', title: 'Terms deleted successfully', dismissAfter: 3000 }))
    if (typeof onSuccess === 'function') {
      yield call(onSuccess)
    }
  } catch (error) {
    yield put({
      type: CHANGE_TERMS_CONDITIONS_REQUEST_ERROR,
      payload: error?.response?.data?.messages || [{ message: 'Failed to delete terms and conditions' }],
    })
    if (typeof onError === 'function') {
      yield call(onError, error)
    }
  } finally {
    yield put(hideLoading())
  }
}

export default function* termsConditions() {
  yield all([
    fork(getTermsConditionsWatcher),
    fork(createTermsConditionsWatcher),
    fork(updateTermsConditionsWatcher),
    fork(deleteTermsConditionsWatcher),
  ])
}
